import { LinkPollDataAction, CommonAction } from 'Actions/index';
import { LinkPollDataActionTypes, CommonActionTypes } from 'Actions/ActionTypes/index';
import { ILinkPollData } from 'Store/Tss/ILinkPollData';
import Util from 'Util/index';

const initialState: ILinkPollData = {};

/**
 * Defines a function to calculate a new state for Link Poll Data
 * based on the given action.  The state must not be directly mutated and
 * the function should always return a new copy of the state.  If nested objects
 * are present be sure to perform a deep copy.
 * @param {} state - the previous state
 * @param {} action  - the action to be performed to calculate the new state
 * @returns {} - a new state object
 */
export const linkPollData = (state = initialState, action: LinkPollDataAction | CommonAction) => {

    let newState: ILinkPollData;

    switch (action.type) {
        case LinkPollDataActionTypes.AddLinkPollData:
        case LinkPollDataActionTypes.ModifyLinkPollData:
            newState = { ...state };
            // ToDo: Need to fix not having an ID on the associated object
            //action.linkPollData.forEach(pollData => {
            //    newState[Util.IdToString(pollData.linkData!.id)] = pollData;
            //});
            break;
        case LinkPollDataActionTypes.DeleteLinkPollData:
            newState = { ...state };
            action.ids.forEach(id => delete newState[Util.IdToString(id!)]);
            break;
        case CommonActionTypes.ClearStore:
            newState = initialState;
            break;
        default:
            newState = state;
    }

    return newState;
}